var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSideHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M415 4146 c-67 -29 -105 -106 -91 -181 9 -47 59 -102 104 -115 26 -8 689 -10 2154 -8 l2117 3 27 21 c53 39 69 71 69 134 0 63 -16 95 -69 134 l-27 21 -2127 2 c-1753 2 -2132 0 -2157 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415 2706 c-67 -29 -105 -106 -91 -181 9 -47 59 -102 104 -115 26 -8 593 -10 1834 -8 l1797 3 27 21 c53 39 69 71 69 134 0 63 -16 95 -69 134 l-27 21 -1807 2 c-1487 2 -1812 0 -1837 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415 1266 c-67 -29 -105 -106 -91 -181 9 -47 59 -102 104 -115 25 -8 377 -10 1114 -8 1069 3 1077 3 1104 24 53 39 69 71 69 134 0 63 -16 95 -69 134 -27 21 -34 21 -1114 23 -888 2 -1093 0 -1117 -11z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideHamburger);
export default __webpack_public_path__ + "static/media/side-hamburger.2e1307a28dc3e28c243eee35a8ac5aa4.svg";
export { ForwardRef as ReactComponent };